/* eslint-disable */
import { useState, useEffect, useRef, useMemo } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";

import JoditEditor from "jodit-react";

//import time calculation
import { getCurrentTime } from "helper/TimeCalculation";
import { reactSelectStyle } from "Config/Config";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import {
  postData,
  getData,
  putData,
  uploadSingleFile,
  uploadMultipleFile,
} from "utils/Gateway";

import fileDownloadHandler from "helper/DownloadFile";
import { assetImages } from "constants";
import { ecosystemSlug } from "Config/Config";
import CurrencyOptions from "data/Prod/Currency.json";
import productStatusOptions from "data/Prod/ProductStatus.json";
import vatOptions from "data/Invoice/VAT.json";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";

import { productDetailsHeaderLinks } from "helper/ProductHelper/ProductHelper";
import AfterSaveProductModal from "../Modals/AfterSaveProductModal";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import FileUploadField from "components/Common/FileUploadField/FileUploadField";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";

const ProductInfoBody = () => {
  const dateOfToday = new Date().toISOString().split("T")[0];

  const { t } = useTranslation(); //for translation

  const params = useParams();
  const history = useHistory();

  // -------- tabs header object --------------------
  const commonHeaderObject = productDetailsHeaderLinks(params.id, t);

  const formRef = useRef(null);

  const loadingCircle = [1, 2, 3, 4, 5, 6]; //for upload image
  const editor = useRef(null);

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  const [productTypeList, setproductTypeList] = useState([]);

  const [companyInput, setCompanyInput] = useState("");
  const [companyList, setCompanyList] = useState([]);

  const [productTypeValue, setproductTypeValue] = useState(null);
  const [selectedProductTypeId, setselectedProductTypeId] = useState(null);
  const [companyValue, setcompanyValue] = useState(null);
  const [selectedCompanyId, setselectedCompanyId] = useState(null);
  const [name, setname] = useState("");
  const [summary, setsummary] = useState("");
  const [details, setdetails] = useState("");
  const [price, setprice] = useState("");
  const [currencyValue, setcurrencyValue] = useState(null);
  const [selectedCurrency, setselectedCurrency] = useState("");
  const [sku, setSku] = useState("");
  const [taxPercent, settaxPercent] = useState("");
  const [unit, setUnit] = useState("");
  const [weight, setweight] = useState("");
  const [length, setlength] = useState("");
  const [width, setwidth] = useState("");
  const [height, setheight] = useState("");
  const [startDate, setstartDate] = useState(dateOfToday || "");
  const [endDate, setendDate] = useState(dateOfToday || "");
  const [productStatusValue, setproductStatusValue] = useState(null);
  const [productStatus, setproductStatus] = useState("");
  const [uploadedPreviewImage, setUploadedPreviewImage] = useState("");
  const [uploadedImageId, setUploadedImageId] = useState(null); // use state for uploaded image id
  const [isUploading, setIsUploading] = useState(false);
  const [isProductFeatured, setIsProductFeatured] = useState(false);
  const [isServiceFeatured, setIsServiceFeatured] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const [savedProductId, setSavedProductId] = useState(null);

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //** Hooks for validation */
  const [errors, setErrors] = useState({});

  const editorCustomConfig = {
    readonly: false,
    minHeight: 300,
    placeholder: "",
    uploader: {
      insertImageAsBase64URI: false,
    },
    events: {
      afterPaste: async (event) => {
        const clipboardData = event.clipboardData || window.clipboardData;
        const items = clipboardData.items;

        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
            const file = items[i].getAsFile();
            const timestamp = Date.now();
            const fileExtension = file.type.split("/")[1];
            const newFileName = `image-${timestamp}.${fileExtension}`;
            const renamedFile = new File([file], newFileName, {
              type: file.type,
            });

            try {
              const requestUrl =
                url.API_BASE_URL +
                url.API_SINGLE_FILE_UPLOAD +
                `?token=${token}`;
              const response = await uploadSingleFile(requestUrl, renamedFile);

              if (response.status) {
                const imageUrl = url.SERVER_URL + response.data.path;
                const editorInstance = editor.current;

                if (editorInstance) {
                  const content = editorInstance.value;
                  const regex = /<img[^>]+src="data:image\/[^">]+"/g;
                  const newContent = content.replace(regex, (match) => {
                    const base64DataMatch = match.match(/src="([^"]+)"/);
                    if (
                      base64DataMatch &&
                      base64DataMatch[1].startsWith("data:image/")
                    ) {
                      return match.replace(base64DataMatch[1], imageUrl);
                    }
                    return match;
                  });

                  editorInstance.value = newContent;
                  setdetails(newContent);
                }
              }
            } catch (error) {
              console.error("Image upload failed:", error);
            }
          }
        }
      },
    },
    defaultActionOnPaste: "insert_as_html",
    defaultLineHeight: 1.5,
    enter: "div",
    statusbar: false,
    sizeLG: 900,
    sizeMD: 700,
    sizeSM: 400,
    toolbarAdaptive: false,
    disablePlugins: [
      "image",
      "video",
      "about",
      "classSpan",
      "file",
      "speechRecognize",
      "copyformat",
      "spellcheck",
      "add-new-line",
    ],
  };

  const editorConfig = useMemo(() => editorCustomConfig, []);

  //** Validate function */
  const validateForm = () => {
    const newErrors = {};

    if (selectedProductTypeId === null) {
      newErrors.type = t(
        "Product type is required. Please select a category for your product.",
      );
    }

    if (selectedCompanyId === null) {
      newErrors.company = t(
        "Company/Store is required. Please associate this product with a company.",
      );
    }

    if (!name.trim()) {
      newErrors.name = t(
        "Product name is required. Please provide a name for your product.",
      );
    }

    if (!summary.trim()) {
      newErrors.summary = t(
        "Summary is required. Please provide a summary for your product.",
      );
    }

    if (!details.trim()) {
      newErrors.details = t(
        "Details are required. Please provide details for your product.",
      );
    }

    if (!sku.trim()) {
      newErrors.sku = t(
        "SKU is required. Please enter a unique Stock Keeping Unit.",
      );
    }

    if (price === "" || price < 0) {
      newErrors.price = t(
        "A valid price is required. Please enter a price of 0 or more.",
      );
    }

    if (taxPercent === "" || taxPercent < 0) {
      newErrors.vat = t(
        "VAT is required. Please enter a valid VAT percentage.",
      );
    }

    if (unit === "" || unit < 0) {
      newErrors.unit = t(
        "Stock quantity is required. Please enter the available units.",
      );
    }

    // Product image validation disabled
    // if (uploadedImageId === null) {
    //   newErrors.image = t(
    //     "A product image is required. Please upload an image."
    //   );
    // }

    // Date comparison validation
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      if (start.getTime() > end.getTime()) {
        newErrors.dateRange = t("End date cannot be earlier than start date.");
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ---- bread crumb text ---- */
  const breadcrumbText = [
    { title: "Product", link: "/admin/marketplace/products/list" },
    { title: t("Vital Info") },
  ];

  // Loader state for product details
  const [isDetailsLoading, setIsDetailsLoading] = useState(false);

  //get all product types
  const getAllProductType = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_PRODUCT_TYPE +
        `?ecosystemslug=${ecosystemSlug}`;

      const response = await getData(requestUrl);

      if (response.status) {
        setproductTypeList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get all contacts
  const getAllCompanyList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY_LIST +
        `?token=${token}&filtername=${companyInput}`;

      const response = await getData(requestUrl);

      if (response.status) {
        setCompanyList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for image upload
  const imageUploadHandler = async (imageFIles) => {
    setErrors((prev) => ({ ...prev, image: "" }));

    const file = imageFIles[0];
    setIsUploading(true);
    try {
      const requestUrl =
        url.API_BASE_URL + url.API_SINGLE_FILE_UPLOAD + `?token=${token}`;

      const response = await uploadSingleFile(requestUrl, file);

      if (response.status) {
        setIsUploading(false);
        setUploadedPreviewImage(response.data.path);
        setUploadedImageId(response.data._id);
        resetImageFile();
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  // function for clear file value
  const resetImageFile = () => {
    const file = document.getElementById("uploadedImageFile");
    if (file) {
      file.value = null;
    } else {
      return;
    }
  };

  //function for select product type
  const productTypeSelectionHandler = (val) => {
    if (errors.type) {
      setErrors((prev) => ({ ...prev, type: "" }));
    }
    if (val) {
      setproductTypeValue(val);
      setselectedProductTypeId(val.value);
    } else {
      setproductTypeValue(null);
      setselectedProductTypeId(null);
    }
  };

  //function for select company
  const companySelectionHandler = (val) => {
    if (errors.company) {
      setErrors((prev) => ({ ...prev, company: "" }));
    }
    if (val) {
      setcompanyValue(val);
      setselectedCompanyId(val.value);
    } else {
      setcompanyValue(null);
      setselectedCompanyId(null);
      setCompanyInput("");
      setCompanyList([]);
    }
  };

  //function for select currency
  const currencySelectionHandler = (val) => {
    if (val) {
      setcurrencyValue(val);
      setselectedCurrency(val.value);
    } else {
      setcurrencyValue(null);
      setselectedCurrency("");
    }
  };

  //function for select product status
  const productStatusSelectionHandler = (val) => {
    if (val) {
      setproductStatusValue(val);
      setproductStatus(val.value);
    } else {
      setproductStatusValue(null);
      setproductStatus("");
    }
  };

  //function for get product details
  const getProductDetails = async () => {
    setIsDetailsLoading(true);
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_PRODUCT_DETAILS +
        `/${params.id}?token=${token}`;

      const response = await getData(requestUrl);

      if (response.status) {
        const data = response.data;

        if (data.producttypevalue) {
          productTypeSelectionHandler(data.producttypevalue);
        }

        if (data.companyvalue) {
          companySelectionHandler(data.companyvalue);
        }

        if (data.currencyValue) {
          currencySelectionHandler(data.currencyValue);
        }

        if (data.productstatusvalue) {
          productStatusSelectionHandler(data.productstatusvalue);
        }

        setname(data.name);
        setSku(data.sku);
        setsummary(data.summary);
        setdetails(data.description);
        setprice(data.price);
        setUnit(data.unit);
        setweight(data.weight);
        setlength(data.length);
        setwidth(data.width);
        setheight(data.height);
        setstartDate(data.startdate);
        setendDate(data.enddate);
        setUploadedImageId(data.productimage);
        setUploadedPreviewImage(data.productimagepath);
        settaxPercent(data.taxpercent);
        setIsProductFeatured(data.isproductfeatured);
        setIsServiceFeatured(data.isservicefeatured);
      } else {
        setAlertMessage(response.message);
        setMessageType("error");
        setShowAlert(true);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
    setIsDetailsLoading(false);
  };

  //function for save product info
  const saveProductInfoHandler = async () => {
    if (!validateForm()) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      return;
    }
    try {
      setIsSaving(true);

      let productData = {
        companyid: selectedCompanyId,
        producttypeid: selectedProductTypeId,
        productimage: uploadedImageId,
        name,
        summary,
        description: details,
        price,
        unit,
        currency: selectedCurrency,
        sku,
        taxpercent: taxPercent,
        stock: unit,
        weight,
        length,
        width,
        height,
        startdate: startDate,
        enddate: endDate,
        productstatus: productStatus,
        isproductfeatured: isProductFeatured,
        isservice: isServiceFeatured,
      };

      let requestUrl = url.API_BASE_URL;

      let response = {};

      if (params.id) {
        requestUrl += url.API_UPDATE_PRODUCT + `/${params.id}?token=${token}`;
        response = await putData(requestUrl, productData);
      } else {
        productData.gallery = [uploadedImageId];
        requestUrl += url.API_ADD_PRODUCT + `?token=${token}`;
        response = await postData(requestUrl, productData);
      }

      console.log("request body", productData);
      console.log("request url", requestUrl);
      console.log("response after save", response);

      setIsSaving(false);

      if (response.status) {
        setSavedProductId(response.data._id);
        setMessageType("success");

        setTimeout(() => {
          const bootstrapModal = new bootstrap.Modal(
            document.getElementById("saveProductinfo"),
          );
          bootstrapModal.show();
        }, 1500);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }

    setShowAlert(true);
  };

  //function for close afterSaveEventModal
  const afterSaveModalClose = (pageName = "") => {
    if (pageName == "details") {
      history.push(`/admin/marketplace/product/details/${savedProductId}`);
    } else {
      history.push("/admin/marketplace/products/list");
    }
  };

  useEffect(() => {
    if (params.id) {
      getProductDetails();
    }
  }, [params.id]);

  useEffect(() => {
    if (companyInput.length > 1) {
      getAllCompanyList();
    }
  }, [companyInput]);

  useEffect(() => {
    getAllProductType();
    currencySelectionHandler(CurrencyOptions[0]);
    productStatusSelectionHandler(productStatusOptions[0]);
  }, []);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  const customTypeStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.type ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.type ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
  };

  const customCompanyStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.company ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.company ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_MARKETPLACE")
  ) {
    return (
      <div id="content_wrapper" ref={formRef}>
        <section className="marketplace-wrapper bg-white">
          {params.id && (
            <TabsHeader
              commonHeaderObject={commonHeaderObject}
              activeOption={t("Vital Info")}
            />
          )}

          <div className="container-fluid px-lg-5 py-4 pb-lg-5 pt-md-0">
            <BreadCrumb
              breadCrumbText={breadcrumbText}
              bottom={true}
              displayName={name || ""}
            />
            {isDetailsLoading ? (
              <div className="p-4 border border-gray-300 rounded-10 shadow-sm">
                {/* Bootstrap Placeholder Loader */}
                <div className="placeholder-glow">
                  <div className="mb-4">
                    <span className="placeholder col-6"></span>
                  </div>
                  <div className="mb-4">
                    <span className="placeholder col-4"></span>
                  </div>
                  <div className="mb-4">
                    <span
                      className="placeholder col-12"
                      style={{ height: "100px", display: "block" }}
                    ></span>
                  </div>
                  <div className="mb-4">
                    <span className="placeholder col-8"></span>
                  </div>
                  <div className="mb-4">
                    <span className="placeholder col-3"></span>
                  </div>
                  <div className="mb-4">
                    <span className="placeholder col-5"></span>
                  </div>
                  <div className="mb-4">
                    <span className="placeholder col-7"></span>
                  </div>
                </div>
              </div>
            ) : (
              <div className="p-4 border border-gray-300 rounded-10 shadow-sm">
                <form onSubmit={(e) => e.preventDefault()}>
                  {/* Product Type and Company */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <div className="row">
                      <div className="col-lg-6 mb-4 mb-lg-0">
                        <label
                          htmlFor="name"
                          className="d-flex align-items-center gap-1 fs-sm fw-semibold mb-2"
                        >
                          {t("Product Type")}
                          <span className="text-danger fw-bold">*</span>
                        </label>
                        <Select
                          isClearable
                          placeholder={t(
                            "Select a category, e.g., Software, Hardware",
                          )}
                          options={productTypeList}
                          value={productTypeValue}
                          onChange={productTypeSelectionHandler}
                          styles={customTypeStyles}
                          className={`${errors.type ? "is-invalid" : ""}`}
                        />
                        {errors.type && (
                          <div className="invalid-feedback d-block mt-2">
                            {errors.type}
                          </div>
                        )}
                      </div>
                      <div className="col-lg-6">
                        <label
                          htmlFor="companyStore"
                          className="d-flex align-items-center gap-1 fs-sm fw-semibold mb-2"
                        >
                          <span className="d-block">
                            {t("Company / Store")}
                          </span>
                          <span className="text-danger fw-bold">*</span>
                        </label>
                        <div className="d-flex align-items-center gap-3">
                          <Select
                            isClearable
                            className={`w-100 ${
                              errors.company ? "is-invalid" : ""
                            }`}
                            placeholder={t(
                              "Search and select the associated company or store",
                            )}
                            options={companyList}
                            value={companyValue}
                            onChange={companySelectionHandler}
                            onInputChange={(val) => {
                              setCompanyInput(val);
                              if (errors.company) {
                                setErrors((prev) => ({ ...prev, company: "" }));
                              }
                            }}
                            styles={customCompanyStyles}
                          />
                          <Link
                            to="/admin/companies/info"
                            target="_blank"
                            className="btn btn-primary d-flex align-items-center"
                          >
                            <span className="d-block material-symbols-outlined icon-fill">
                              add
                            </span>
                          </Link>
                        </div>
                        {errors.company && (
                          <div className="invalid-feedback d-block mt-2">
                            {errors.company}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* Product Name and SKU */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <div className="row">
                      <div className="col-lg-6 mb-4 mb-lg-0">
                        <label
                          htmlFor="name"
                          className="d-flex align-items-center gap-1 fs-sm fw-semibold mb-2"
                        >
                          <span className="d-block">{t("Product Name")}</span>
                          <span className="text-danger fw-bold">*</span>
                        </label>
                        <input
                          type="text"
                          id="name"
                          className={`form-control fs-sm shadow-none ${
                            errors.name ? "is-invalid" : "border-gray-300"
                          }`}
                          placeholder={t(
                            "E.g., Premium Software License, High-Performance Laptop",
                          )}
                          value={name}
                          onChange={(e) => {
                            setname(e.target.value);
                            setErrors((prev) => ({ ...prev, name: "" }));
                          }}
                        />
                        {errors.name && (
                          <div className="invalid-feedback mt-2">
                            {errors.name}
                          </div>
                        )}
                      </div>
                      <div className="col-lg-6">
                        <label
                          htmlFor="sku"
                          className="d-flex align-items-center gap-1 fs-sm fw-semibold mb-2"
                        >
                          <span className="d-block">{t("SKU")}</span>
                          <span className="text-danger fw-bold">*</span>
                        </label>
                        <input
                          type="text"
                          id="sku"
                          className={`form-control fs-sm shadow-none ${
                            errors.sku ? "is-invalid" : "border-gray-300"
                          }`}
                          placeholder={t(
                            "Enter a unique code for inventory, e.g., PROD-SW-001",
                          )}
                          value={sku}
                          onChange={(e) => {
                            setSku(e.target.value);
                            setErrors((prev) => ({ ...prev, sku: "" }));
                          }}
                        />
                        {errors.sku && (
                          <div className="invalid-feedback mt-2">
                            {errors.sku}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Summary */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="summary"
                      className="d-flex align-items-center gap-1 fs-sm fw-semibold mb-2"
                    >
                      <span className="d-block">{t("Summary")}</span>
                      <span className="text-danger fw-bold">*</span>
                    </label>
                    <textarea
                      name="summary"
                      id="summary"
                      cols="30"
                      rows="5"
                      className={`form-control fs-sm shadow-none ${
                        errors.summary ? "is-invalid" : "border-gray-300"
                      }`}
                      placeholder={t(
                        "Write a short, catchy summary of the product's main benefits.",
                      )}
                      value={summary}
                      onChange={(e) => {
                        setsummary(e.target.value);
                        setErrors((prev) => ({ ...prev, summary: "" }));
                      }}
                    ></textarea>
                    {errors.summary && (
                      <div className="invalid-feedback mt-2">
                        {errors.summary}
                      </div>
                    )}
                  </div>
                  {/* Details */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="details"
                      className="d-flex align-items-center gap-1 fs-sm fw-semibold mb-2"
                    >
                      <span className="d-block">{t("Details")}</span>
                      <span className="text-danger fw-bold">*</span>
                    </label>
                    <JoditEditor
                      ref={editor}
                      value={details}
                      config={editorConfig}
                      onBlur={(newContent) => {
                        setdetails(newContent);
                        setErrors((prev) => ({ ...prev, details: "" }));
                      }}
                    />
                    {errors.details && (
                      <div className="invalid-feedback d-block mt-2">
                        {errors.details}
                      </div>
                    )}
                  </div>
                  {/* Price, Currency, VAT, Stock */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <div className="row">
                      <div className="col-lg mb-4 mb-lg-0">
                        <label
                          htmlFor="price"
                          className="d-block fs-sm fw-semibold mb-2"
                        >
                          {t("Price")}
                          <span className="text-danger fw-bold">*</span>
                        </label>
                        <input
                          type="number"
                          min={0}
                          id="price"
                          className={`form-control fs-sm shadow-none ${
                            errors.price ? "is-invalid" : "border-gray-300"
                          }`}
                          placeholder={t("E.g., 99.99")}
                          value={price}
                          onChange={(e) => {
                            setprice(e.target.value);
                            setErrors((prev) => ({ ...prev, price: "" }));
                          }}
                        />
                        {errors.price && (
                          <div className="invalid-feedback mt-2">
                            {errors.price}
                          </div>
                        )}
                      </div>
                      <div className="col-lg mb-4 mb-lg-0">
                        <label
                          htmlFor="currency"
                          className="d-block fs-sm fw-semibold mb-2"
                        >
                          {t("Currency")}
                        </label>
                        <Select
                          isClearable
                          placeholder={t("Select currency")}
                          options={CurrencyOptions}
                          value={currencyValue}
                          onChange={currencySelectionHandler}
                          styles={reactSelectStyle("3px", "6px", true, false)}
                        />
                      </div>
                      <div className="col-lg mb-4 mb-lg-0">
                        <label
                          htmlFor="vat"
                          className="d-block fs-sm fw-semibold mb-2"
                        >
                          {t("VAT %")}
                          <span className="text-danger fw-bold">*</span>
                        </label>
                        <input
                          type="number"
                          min={0}
                          id="vat"
                          className={`form-control fs-sm shadow-none ${
                            errors.vat ? "is-invalid" : "border-gray-300"
                          }`}
                          placeholder={t("E.g., 20")}
                          value={taxPercent}
                          onChange={(e) => {
                            settaxPercent(e.target.value);
                            setErrors((prev) => ({ ...prev, vat: "" }));
                          }}
                        />
                        {errors.vat && (
                          <div className="invalid-feedback mt-2">
                            {errors.vat}
                          </div>
                        )}
                      </div>
                      <div className="col-lg mb-4 mb-lg-0">
                        <label
                          htmlFor="stock"
                          className="d-block fs-sm fw-semibold mb-2"
                        >
                          {t("Stock")}
                          <span className="text-danger fw-bold">*</span>
                        </label>
                        <input
                          min={0}
                          type="number"
                          id="stock"
                          className={`form-control fs-sm shadow-none ${
                            errors.unit ? "is-invalid" : "border-gray-300"
                          }`}
                          placeholder={t("E.g., 100")}
                          value={unit}
                          onChange={(e) => {
                            setUnit(e.target.value);
                            setErrors((prev) => ({ ...prev, unit: "" }));
                          }}
                        />
                        {errors.unit && (
                          <div className="invalid-feedback mt-2">
                            {errors.unit}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* Weight, Length, Width, Height */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <div className="row">
                      <div className="col-lg mb-4 mb-lg-0">
                        <label
                          htmlFor="weight"
                          className="d-block fs-sm fw-semibold mb-2"
                        >
                          {t("Weight (kg)")}
                        </label>
                        <input
                          min={0}
                          type="number"
                          id="weight"
                          className="form-control fs-sm shadow-none border-gray-300"
                          placeholder={t("E.g., 0.5")}
                          value={weight}
                          onChange={(e) => setweight(e.target.value)}
                        />
                      </div>
                      <div className="col-lg mb-4 mb-lg-0">
                        <label
                          htmlFor="length"
                          className="d-block fs-sm fw-semibold mb-2"
                        >
                          {t("Length (cm)")}
                        </label>
                        <input
                          min={0}
                          type="number"
                          id="length"
                          className="form-control fs-sm shadow-none border-gray-300"
                          placeholder={t("E.g., 10")}
                          value={length}
                          onChange={(e) => setlength(e.target.value)}
                        />
                      </div>
                      <div className="col-lg mb-4 mb-lg-0">
                        <label
                          htmlFor="width"
                          className="d-block fs-sm fw-semibold mb-2"
                        >
                          {t("Width (cm)")}
                        </label>
                        <input
                          min={0}
                          type="number"
                          id="width"
                          className="form-control fs-sm shadow-none border-gray-300"
                          placeholder={t("E.g., 5")}
                          value={width}
                          onChange={(e) => setwidth(e.target.value)}
                        />
                      </div>
                      <div className="col-lg mb-4 mb-lg-0">
                        <label
                          htmlFor="height"
                          className="d-block fs-sm fw-semibold mb-2"
                        >
                          {t("Height (cm)")}
                        </label>
                        <input
                          min={0}
                          type="number"
                          id="height"
                          className="form-control fs-sm shadow-none border-gray-300"
                          placeholder={t("E.g., 2")}
                          value={height}
                          onChange={(e) => setheight(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Advanced Information Accordion */}
                  <div
                    className="accordion mb-4"
                    id="accordionPanelsStayOpenExample"
                  >
                    <div className="accordion-item bg-transparent border-0">
                      <h3 className="accordion-header">
                        <button
                          className="accordion-button bg-transparent p-0 shadow-none"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#panelsStayOpen-collapseOne"
                          aria-expanded="true"
                          aria-controls="panelsStayOpen-collapseOne"
                        >
                          {t("Advanced Information")}
                        </button>
                      </h3>
                      <div
                        id="panelsStayOpen-collapseOne"
                        className="accordion-collapse collapse show"
                      >
                        <div className="accordion-body p-0 pt-4">
                          {/* Display Dates and Product Status */}
                          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                            <div className="row">
                              <div className="col-lg-4 mb-4 mb-lg-0">
                                <label
                                  htmlFor="displayStartFrom"
                                  className="d-block fs-sm fw-semibold mb-2"
                                >
                                  {t("Display Start Date")}
                                </label>
                                <input
                                  type="date"
                                  className={`form-control fs-sm shadow-none ${
                                    errors.dateRange
                                      ? "is-invalid"
                                      : "border-gray-300"
                                  }`}
                                  value={startDate}
                                  onChange={(e) => {
                                    setstartDate(e.target.value);
                                    setErrors((prev) => ({
                                      ...prev,
                                      dateRange: "",
                                    }));
                                  }}
                                />
                              </div>
                              <div className="col-lg-4 mb-4 mb-lg-0">
                                <label
                                  htmlFor="displayEndFrom"
                                  className="d-block fs-sm fw-semibold mb-2"
                                >
                                  {t("Display End Date")}
                                </label>
                                <input
                                  type="date"
                                  className={`form-control fs-sm shadow-none ${
                                    errors.dateRange
                                      ? "is-invalid"
                                      : "border-gray-300"
                                  }`}
                                  value={endDate}
                                  onChange={(e) => {
                                    setendDate(e.target.value);
                                    setErrors((prev) => ({
                                      ...prev,
                                      dateRange: "",
                                    }));
                                  }}
                                />
                                {errors.dateRange && (
                                  <div className="invalid-feedback d-block mt-2">
                                    {errors.dateRange}
                                  </div>
                                )}
                              </div>
                              <div className="col-lg-4">
                                <label
                                  htmlFor="displayEndFrom"
                                  className="d-block fs-sm fw-semibold mb-2"
                                >
                                  {t("Product Status")}
                                </label>
                                <Select
                                  isClearable
                                  placeholder={t(
                                    "Set the product status, e.g., Active, Draft",
                                  )}
                                  options={productStatusOptions}
                                  value={productStatusValue}
                                  onChange={productStatusSelectionHandler}
                                  styles={reactSelectStyle(
                                    "3px",
                                    "6px",
                                    true,
                                    false,
                                  )}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Image Upload */}
                          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                            <label
                              htmlFor="productImage"
                              className="d-block fs-sm fw-semibold mb-2"
                            >
                              {t("Product Image")}
                            </label>
                            <FileUploadField
                              label={t("Image")}
                              accept="jpg png jpeg"
                              onUpload={imageUploadHandler}
                              files={
                                uploadedPreviewImage === ""
                                  ? [
                                      {
                                        path: "https://placehold.co/150x150",
                                        name: "Product Image",
                                      },
                                    ]
                                  : [
                                      {
                                        path:
                                          url.SERVER_URL + uploadedPreviewImage,
                                        name: "Product Image",
                                      },
                                    ]
                              }
                              onRemove={() => {
                                setUploadedPreviewImage("");
                                setUploadedImageId(null);
                              }}
                              loading={isUploading}
                              fileType="image"
                            />
                          </div>
                          {/* Privacy Settings */}
                          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                            <p className="mb-3 fs-md fw-semibold">
                              {t("Mark as Service")}
                            </p>
                            <div className="form-check mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                                checked={isServiceFeatured}
                                onChange={(e) => {
                                  setIsServiceFeatured(e.target.checked);
                                }}
                                id="privateEvent"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="privateEvent"
                              >
                                {t("Add this item as Service")}
                              </label>
                            </div>

                            <p className="mb-3 fs-md fw-semibold">
                              {t("Mark as Featured Item")}
                            </p>
                            <div className="form-check mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                                checked={isProductFeatured}
                                onChange={(e) => {
                                  setIsProductFeatured(e.target.checked);
                                }}
                                id="privateEvent"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="privateEvent"
                              >
                                {t("Add this as featured item")}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            )}
          </div>

          {/* Fixed Footer */}
          <div
            className="fixed-bottom bg-white shadow-lg border-top"
            style={{ zIndex: 1000 }}
          >
            <div className="container-fluid px-lg-5 py-3">
              <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
                <Link
                  to="/admin/marketplace/products/list"
                  className="btn btn-outline-primary px-4"
                >
                  {t("Cancel")}
                </Link>
                <button
                  type="submit"
                  className="btn btn-primary px-4 d-flex align-items-center"
                  disabled={isSaving}
                  onClick={saveProductInfoHandler}
                >
                  {isSaving ? t("Saving...") : t("Save Product")}
                  {isSaving && (
                    <div
                      className="ms-2 spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}
                </button>
              </div>
            </div>
          </div>

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}

          <AfterSaveProductModal
            productId={savedProductId}
            afterSaveModalClose={afterSaveModalClose}
          />
        </section>
      </div>
    );
  } else {
    // Access denied view for unauthorized users
    return <AccessDeniedView />;
  }
};

export default ProductInfoBody;
